// extracted by mini-css-extract-plugin
module.exports = {"vacationbalance":"vacationbalance___3BLmz"};